import React from 'react';
import Uploader from './uploader';
import { Card, Checkbox, Empty, Modal, Popconfirm, Space, Spin, Tooltip, Typography } from 'antd';
import './editRenaming.scss';
import { DeleteOutlined, EditOutlined, EyeInvisibleTwoTone, EyeTwoTone, QuestionCircleOutlined } from '@ant-design/icons';
import { useDeletePreset, useDeletePresetGuideline, useUpdatePresetStatus } from '../../hooks/useAnglePreset';
import { useEffect } from 'react';
import useLogout from '../../hooks/useLogout';

const EditModal = ({
    openAnglePresetGuidelines,
    setOpenAnglePresetGuidelines,
    editPresetId,
    presetData,
    setPresetData,
    getEditDetails,
    fetchingDetails,
    presetName,
}) => {
    const { logout } = useLogout();
    const { mutate: updateStatus, isLoading: isUpdating } = useUpdatePresetStatus(onSuccess, onError);
    const { mutate: deleteGuideline, isLoading: isDeleting } = useDeletePresetGuideline(onSuccessDel, onErrorDel);

    const visibleOptions = ['Client', 'Studio', 'Editor'];

    const handleUpdateGuideList = data => {
        setPresetData(data);
    };

    function onSuccess(res) {
        // handleUpdateGuideList(res.data.editingGuidelines);
        handleUpdateGuideList(res.data.guidelines);
    }
    function onError(err) {
        console.log(err);
        if (err?.response?.status === 401) logout();
    }
    function onSuccessDel(response) {
        // handleUpdateGuideList(response.data.editingGuidelines);
        handleUpdateGuideList(response.data.guidelines);
    }
    function onErrorDel(err) {
        console.log(err);
        if (err?.response?.status === 401) logout();
    }

    const handleStatus = data => {
        let callObj = {
            anglePresetId: editPresetId,
            guidelineId: data._id,
            status: !data.isActive,
        };
        updateStatus(callObj);
    };
    const handleDeleteGuideline = id => {
        let deleteObj = {
            anglePresetId: editPresetId,
            guidelineId: id,
        };
        deleteGuideline(deleteObj);
    };
    const handleVisibility = (data, id) => {
        let tempObj = {
            anglePresetId: editPresetId,
            guidelineId: id,
            visibility: data,
        };
        updateStatus(tempObj);
    };
    useEffect(() => {
        return () => setPresetData([]);
    }, []);
    return (
        <Modal
            width="80%"
            footer={null}
            open={openAnglePresetGuidelines}
            onCancel={() => setOpenAnglePresetGuidelines(false)}
            style={{
                height: '90%',
                top: '25px',
            }}
            closable={false}
            className="editModal"
            title={<h2>{presetName}</h2>}
        >
            <div
                style={{
                    width: '100%',
                    height: '80vh',
                    overflowY: 'auto',
                }}
            >
                <div>
                    <Uploader editPresetId={editPresetId} getEditDetails={getEditDetails} />
                </div>
                <hr />
                <Spin spinning={fetchingDetails || isUpdating || isDeleting}>
                    <div className="flexBox cards_container">
                        {/* {presetData.map(item => (
                        <Card>
                            <Space direction="vertical" align="center">
                                <img src={item.image.imagePath.url} style={{ height: '16vh', width: 'auto', objectFit: 'contain' }} />
                                <span>{item.name}</span>
                            </Space>
                        </Card>
                    ))} */}
                        {presetData?.length > 0 ? (
                            <>
                                <div
                                    className="article_wrapper"
                                    style={{
                                        height: '100%',
                                        gap: '16px',
                                    }}
                                >
                                    {presetData?.map((article, index) => (
                                        <div key={article._id} className="article_container">
                                            {/* {!article.isActive && (
                                                <Popconfirm
                                                    title="Delete the preset"
                                                    description="Are you sure you want to delete this article?"
                                                    icon={
                                                        <QuestionCircleOutlined
                                                            style={{
                                                                color: 'red',
                                                            }}
                                                        />
                                                    }
                                                    onConfirm={() => handleDeleteGuideline(article._id)}
                                                >
                                                    <div className={`deleteIcon`}>
                                                        <DeleteOutlined />
                                                    </div>
                                                </Popconfirm>
                                            )} */}
                                            <Tooltip title={article.isActive ? 'Disable' : 'Enable'}>
                                                <div className="editIcon" onClick={() => handleStatus(article)}>
                                                    {article.isActive ? (
                                                        <EyeTwoTone twoToneColor="#52c41a" />
                                                    ) : (
                                                        <EyeInvisibleTwoTone twoToneColor="#ff0028" />
                                                    )}
                                                </div>
                                            </Tooltip>
                                            {!article.isActive && (
                                                <Popconfirm
                                                    title="Delete the preset"
                                                    description="Are you sure you want to delete this article?"
                                                    icon={
                                                        <QuestionCircleOutlined
                                                            style={{
                                                                color: 'red',
                                                            }}
                                                        />
                                                    }
                                                    onConfirm={() => handleDeleteGuideline(article._id)}
                                                >
                                                    <div className={`deleteIcon`}>
                                                        <DeleteOutlined />
                                                    </div>
                                                </Popconfirm>
                                            )}

                                            <img alt="article_img" className="article_image" src={article?.image?.thumbPath?.url} />
                                            <Space direction="vertical" align="center">
                                                <label>
                                                    <u>Visible To</u>
                                                </label>
                                                <Checkbox.Group
                                                    className={'article_checkBox'}
                                                    options={visibleOptions}
                                                    defaultValue={article?.visibility ?? []}
                                                    value={article?.visibility ?? []}
                                                    onChange={e => handleVisibility(e, article._id)}
                                                />
                                            </Space>
                                        </div>
                                    ))}
                                </div>
                            </>
                        ) : (
                            <Empty
                                description="No data available"
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                imageStyle={{ marginTop: '200px' }}
                                style={{ margin: 'auto' }}
                            />
                        )}
                    </div>
                </Spin>
            </div>
        </Modal>
    );
};

export default EditModal;
